import React from "react";
import { useMobile, useTab } from "../../hooks/deviceHooks/useDevice.hooks";

interface ChildrenProps {
  component: any;
  gridSpan: number;
  style?: React.CSSProperties;
}

export enum GRID_SPACE {
  sm = "sm",
  md = "md",
}

interface Props {
  totalColumns: number;
  childrens: ChildrenProps[];
  gridSpace?: GRID_SPACE;
}

export const GridWrapper = ({
  totalColumns,
  childrens,
  gridSpace = GRID_SPACE.md,
}: Props) => {
  const isMobile = useMobile();
  const isTab = useTab();

  const column = isMobile || isTab ? 1 : totalColumns;

  return (
    <div
      style={{
        display: "grid",
        gap: "24px",
        gridTemplateColumns: `repeat(${column}, 1fr)`,
        // marginTop: `${marginSpace}px`,
      }}
    >
      {childrens.map(({ component, gridSpan, style }) => {
        const _gridSpan = isMobile || isTab ? 1 : gridSpan;

        return (
          <div
            style={{
              gridColumn: `span ${_gridSpan}`,
              height: "100%",
              ...(style || {}),
            }}
          >
            {component}
          </div>
        );
      })}
    </div>
  );
};
